import React, { useEffect, useState, useRef } from 'react';
import { Container, Complemento } from './styles2';

import WebFont from "webfontloader";
import LogoErpWorks from "~/assets/logos/Logo ErpWorks Proposta.png";

function Pagina2({ data }) {
  let linhas = "";//string.match(/(\r\n|\n|\r)/gm);
  let quantidadeLinhas = linhas ? linhas.length : 0;
  let resto = 0;

  return (
    <>
      <Container>
        <div className="barra-sup"></div>
        <div className="barra-sup2"></div>
        <div className="barra-sup3"></div>
        <div className="barra-sup4"></div>
        <div className="header">
          <div class="text">
            <p class="titulo">Data Emissão</p>
            <p class="titulo-data">{(new Date().toLocaleString('pt-BR', { timeZone: 'UTC' }))}</p>
          </div>
        </div>
        <div className="body">
          <div className="mid">
            <div class="text">
              <p class="tit">À</p>
              <p class="titulo">{data?.projeto?.cliente?.nomeFantasia}</p>
              <p class="titulo">{data?.projeto?.cliente?.razaoSocial}</p>
              <p class="titulo">{data?.projeto?.cliente?.identificacao}</p>
            </div>
            <div class="text">
              <p class="titulo">A/C</p>
              <p class="titulo">{data?.projeto?.solicitante_cliente?.nome}</p>
              <p class="titulo">{data?.projeto?.solicitante_cliente?.email}</p>
            </div>
          </div>
          <div className="bottom">
            <div class="text">
              <p class="titulo">REFERENTE: {data?.titulo}</p>
            </div>
          </div>
        </div>

        <img className='logo-rodape' src={LogoErpWorks} alt="Logo Erpworks" />
      </Container >
    </>
  );
};

export default Pagina2;